/*
 * @Author: 李才人
 * @Date: 2021-07-08 10:00:00
 * @LastEditors: 李才人
 * @LastEditTime: 2021-07-27 15:01:51
 * @FilePath: \m_saas_business_admin\src\dataBase\authCodeMap\operation.ts
 * @Description: 运营模块code码
 */
export const operation = {
  operationTools: "operationTools",
  operationTools_questionnaire: "operationTools_questionnaire",
  operationTools_questionnaire_add: "operationTools_questionnaire_add",
  operationTools_questionnaire_export: "operationTools_questionnaire_export",
  operationTools_questionnaire_edit_button: "operationTools_questionnaire_edit_button",
  operationTools_questionnaire_online_offline: "operationTools_questionnaire_online_offline",
  operationTools_questionnaire_share: "operationTools_questionnaire_share",
  operationTools_questionnaire_visit: "operationTools_questionnaire_visit",
  operationTools_questionnaire_data: "operationTools_questionnaire_data",
  operationTools_questionnaire_copy: "operationTools_questionnaire_copy",
  operationTools_questionnaire_delete: "operationTools_questionnaire_delete",
  questionnaire_edit: "questionnaire_edit",
  operationTools_questionBank_addBtn: "operationTools_questionBank_addBtn",
  operationTools_questionBank_batchImportBtn: "operationTools_questionBank_batchImportBtn",
  operationTools_questionBank_exportBtn: "operationTools_questionBank_exportBtn",
  operationTools_questionBank_editBtn: "operationTools_questionBank_editBtn",
  operationTools_questionBank_delBtn: "operationTools_questionBank_delBtn",
  operationTools_questionBank_viewBtn: "operationTools_questionBank_viewBtn",
  operationTools_questionBank_catalogManageBtn: "operationTools_questionBank_catalogManageBtn",
  ncme_questionBank_addBtn: "ncme_questionBank_addBtn",
  ncme_questionBank_batchImportBtn: "ncme_questionBank_batchImportBtn",
  ncme_questionBank_exportBtn: "ncme_questionBank_exportBtn",
  ncme_questionBank_editBtn: "ncme_questionBank_editBtn",
  ncme_questionBank_delBtn: "ncme_questionBank_delBtn",
  ncme_questionBank_viewBtn: "ncme_questionBank_viewBtn",
  ncme_questionBank_catalogManageBtn: "ncme_questionBank_catalogManageBtn",
  operationTools_catalogManage_addBtn: "operationTools_catalogManage_addBtn",
  operationTools_catalogManage_editBtn: "operationTools_catalogManage_editBtn",
  operationTools_catalogManage_delBtn: "operationTools_catalogManage_delBtn",
  ncme_catalogManage_addBtn: "ncme_catalogManage_addBtn",
  ncme_catalogManage_editBtn: "ncme_catalogManage_editBtn",
  ncme_catalogManage_delBtn: "ncme_catalogManage_delBtn",
  ncme_questionaireManageTabPane: "ncme_questionaireManageTabPane",
  operationTools_questionaireManageTabPane: "operationTools_questionaireManageTabPane",
  ncme_questionBankTabPane: "ncme_questionBankTabPane",
  operationTools_questionBankTabPane: "operationTools_questionBankTabPane"
};